import React, { useState } from "react";
import "./Whychoose.css";

const EndToEndSolutions = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const steps = [
    {
      title: "Renewable Energy",
      content:"Solar power harnesses energy from the sun, which is a renewable and virtually inexhaustible resource. Unlike fossil fuels, which are finite and contribute to climate change, solar energy is clean and sustainable.",
      color: "#3A954F",
    },
    {
      title: "Cost Savings",
      content:"Installing a solar system can lead to significant cost savings over time. While the initial investment may seem high, solar panels have a long lifespan and require minimal maintenance. Once installed, solar power can help reduce or eliminate electricity bills, resulting in long-term financial benefits.",
      color: "#3A954F",
    },
    {
      title: "Environmental Impact",
      content:"Solar energy is a clean source of power that produces zero greenhouse gas emissions during operation. By utilizing solar power, you can contribute to reducing air pollution and combatting climate change.",
      color: "#3A954F",
    },
    {
      title: "Energy Independence",
      content:"Generating your own electricity with a solar system gives you greater energy independence. It reduces reliance on traditional energy sources, such as fossil fuels, and provides a reliable source of power even in remote locations.",
      color: "#3A954F",
    },
    {
      title: "Incentives and Subsidy",
      content:"Many governments and utility companies offer subsidy for installing solar systems. These incentives can help offset the initial installation costs and make solar power more affordable.",
      color: "#3A954F",
    },
    {
      title: "Long-Term Investment",
      content:"Investing in a solar system is not only beneficial in the short term but also in the long run. Solar panels have a lifespan of 25-30 years or more, and their value can increase the overall resale value of your property.",
      color: "#3A954F",
    },
  ];

  return (
    <section className="ees-section-Whychoose">
      <div className="ees-container-Whychoose">
        {/* LEFT TEXT */}
        <div className="ees-left-Whychoose">
          <h2 className="ees-title-Whychoose">
            ⚡ Why Choose Us?
          </h2>
          <p className="ees-desc-Whychoose">
            CM Green Energy India Private Limited provides an extreme level of service by offering complete, end-to-end solutions for Wind and Solar projects, simplifying the complex process into three core phases:
          </p>
        </div>

        {/* RIGHT ACCORDION */}
        <div className="ees-right-Whychoose">
          {steps.map((step, index) => (
            <div
              key={index}
              className="ees-card-Whychoose"
              style={{ backgroundColor: step.color }}
            >
              <div
                className="ees-card-header-Whychoose"
                onClick={() => toggle(index)}
              >
                <h3>{step.title}</h3>

                <span
                  className={
                    openIndex === index
                      ? "ees-arrow-Whychoose rotate"
                      : "ees-arrow-Whychoose"
                  }
                >
                  ^
                </span>
              </div>

              <div className={`ees-card-body-Whychoose ${openIndex === index ? "open" : ""}`}>
  <p>{step.content}</p>
</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EndToEndSolutions;
